export default __webpack_public_path__ + "static/media/img39.e41d3466.jpg";